import jQuery from 'jquery';
let $ = jQuery;

import "./Application.js";
import "./DataLayer.js";

function cmCreateManualLinkClickTag() { }
function cmCreateManualImpressionTag() { }
function cmCreateManualPageviewTag() { }
function cmCreateElementTag() { }
function cmCreatePageElementTag() { }
function cmCreateProductElementTag() { }
function cmCreateConversionEventTag() { }
function cmCreatePageviewTag() { }
function cmCreateProductviewTag() { }
function cmCreateShopAction5Tag() { }
function cmCreateShopAction9Tag() { }
function cmCreateOrderTag() { }
function cmCreateRegistrationTag() { }
function cX() { }

window.cmCreateManualLinkClickTag  = cmCreateManualLinkClickTag;
window.cmCreateManualImpressionTag = cmCreateManualImpressionTag;
window.cmCreateManualPageviewTag   = cmCreateManualPageviewTag;
window.cmCreateElementTag          = cmCreateElementTag;
window.cmCreatePageElementTag      = cmCreatePageElementTag;
window.cmCreateProductElementTag   = cmCreateProductElementTag;
window.cmCreateConversionEventTag  = cmCreateConversionEventTag;
window.cmCreatePageviewTag         = cmCreatePageviewTag;
window.cmCreateProductviewTag      = cmCreateProductviewTag;
window.cmCreateShopAction5Tag      = cmCreateShopAction5Tag;
window.cmCreateShopAction9Tag      = cmCreateShopAction9Tag;
window.cmCreateOrderTag            = cmCreateOrderTag;
window.cmCreateRegistrationTag     = cmCreateRegistrationTag;
window.cX                          = cX;


//if (HSN.Application.prototype.GetQueryStringParam(window.location.search, 'cm_re').length > 0) {
//    var realEstateTag = HSN.Application.prototype.GetQueryStringParam(window.location.search, 'cm_re');
//    HSN.DataLayer.helpers.realEstate(null, realEstateTag);
//}

(function interceptCmCreateManualLinkClickTag() {
    window.cmCreateManualLinkClickTag = function (href) {
        var realEstateTag = HSN.Application.prototype.GetQueryStringParam(href, 'cm_re');
        HSN.DataLayer.helpers.realEstate(null, realEstateTag);
    };
})();

window.manualCmReClickHandler = jQuery('body').on('click.coremetricsRealEstate', 'a[manual_cm_re]', function (e) {
    var re = $(this).attr('manual_cm_re');
    HSN.DataLayer.helpers.realEstate(null, re);
});



// WEBPACK FOOTER //
// ./assets/js/HSN/CoremetricsPatch.js